import { render } from "./EditCerereDetail.vue?vue&type=template&id=208ac1b7&scoped=true&ts=true"
import script from "./EditCerereDetail.ts?vue&type=script&lang=ts&external"
export * from "./EditCerereDetail.ts?vue&type=script&lang=ts&external"

import "./EditCerereDetail.vue?vue&type=style&index=0&id=208ac1b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208ac1b7"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QForm,QBtn,QTooltip,QSpinner,QMenu,QField});
